// extracted by mini-css-extract-plugin
export default {"modal":"_1Pbls_modal","modal-hidden":"LxoDY_modal-hidden"};